export const createDots = (inputString: any) => {
  if (!inputString) {
    return "";
  }
  let dots = "";
  for (let i = 0; i < inputString.length; i++) {
    dots += "•";
  }
  return dots;
};
